{
	"cardHeader": "Accédez à vos déclarations",
	"supplierTitle": "Êtes-vous le fournisseur d’une déclaration evoZero ?",
	"supplierDescription": "Gérez les déclarations pour vos matériaux evoZero.",
	"loginButton": "Connexion"
}
